
import React from 'react'
import { AuthStore } from '../../stores'

const UserIcon = (props) => <div className={ `user-icon ${ props.className }` } style={ { backgroundColor: '#7B529C' } }>
  <h1 className="h1 bold white s20">{ (AuthStore.user || {firstname: ''}).firstname.charAt(0) }</h1>
</div>

export default UserIcon
